import "./style.scss";
import * as React from "react";
import moment from "moment";

import Section from "../../../../core/Section";
import Row from "../../../../core/Row";
import { Checkbox, Select } from "../../../../form";
import Radio, { RadioGroup } from "../../../../form/Radio";
import { Form, Input, Icon, Popover } from "antd";
import FilenamePopover from "./FilenamePopover";
import ReportNamePopover from "./ReportNamePopover";
import DelimiterPopover from "./DelimiterPopover";
import ReportingPeriodPopover from "./ReportingPeriodPopover";

const FormItem = Form.Item;

class ReportFormat extends React.Component<
  ReportFormatProps & ReportFormatActions,
  {}
> {
  render() {
    const { getFieldDecorator } = this.props.form;

    return (
      <Section className="report-format" title="Report Format">
        <Row>
          <div className="label required">
            Filename &nbsp;&nbsp;&nbsp;
            <Popover
              placement="topLeft"
              content={FilenamePopover}
              title="Help"
              trigger="hover"
            >
              <Icon type="question-circle" />
            </Popover>
          </div>

          <div className="long">
            <FormItem hasFeedback>
              {getFieldDecorator("filename", {
                rules: [
                  { required: true, message: "Please specify a filename" }
                ],
                initialValue: this.props.filename
              })(
                <Input
                  placeholder="my_report_file"
                  onChange={(e: any) => this.props.editFilename(e.target.value)}
                />
              )}
            </FormItem>
          </div>

          <div className="preview">preview: {this.props.preview}</div>
        </Row>

        <Row>
          <div className="label required">
            Report Name &nbsp;&nbsp;&nbsp;
            <Popover
              placement="topLeft"
              content={ReportNamePopover}
              title="Help"
              trigger="hover"
            >
              <Icon type="question-circle" />
            </Popover>
          </div>
          <div className="long">
            <Form.Item hasFeedback>
              {getFieldDecorator("name", {
                rules: [{ required: true, message: "Please specify a name" }],
                initialValue: this.props.name
              })(
                <Input
                  placeholder="My Report"
                  onChange={(e: any) => this.props.editName(e.target.value)}
                />
              )}
            </Form.Item>
          </div>
        </Row>

        <Row>
          <div className="label">Description (Optional)</div>
          <div className="long">
            <Input
              value={this.props.description}
              placeholder="My Daily Report for ..."
              onChange={(e: any) => this.props.editDescription(e.target.value)}
            />
          </div>
        </Row>

        <Row>
          <div className="label">
            Delimiter &nbsp;&nbsp;&nbsp;
            <Popover
              placement="topLeft"
              content={DelimiterPopover}
              title="Help"
              trigger="hover"
            >
              <Icon type="question-circle" />
            </Popover>
          </div>
          <RadioGroup
            value={this.props.delimiter}
            handleChange={(e) => this.props.editDelimiter(e.target.value)}
          >
            <Radio className="field-width" value={","} label="comma [ , ]" />
            <Radio className="field-width" value={"\\t"} label="tab [ \\t ]" />
            <Radio className="field-width" value={"|"} label="pipe [ | ]" />
          </RadioGroup>
        </Row>

        <Row>
          <div className="label">Compression (gzip)</div>
          <Checkbox
            label="Enable"
            checked={this.props.compressed}
            handleChange={() => this.props.toggleCompressed()}
          />
        </Row>

        <Row>
          <div className="label">
            Reporting Period &nbsp;&nbsp;&nbsp;
            <Popover
              placement="topLeft"
              content={ReportingPeriodPopover}
              title="Help"
              trigger="hover"
            >
              <Icon type="question-circle" />
            </Popover>
          </div>
          <RadioGroup
            value={this.props.duration}
            handleChange={(e) => this.props.editDuration(e.target.value)}
          >
            <Radio className="field-width" value={"one_day"} label="1 Day" />
            <Radio className="field-width" value={"one_week"} label="1 Week" />
            <Radio
              className="field-width"
              value={"one_month"}
              label="1 Month"
            />
            <Radio
              className="field-width"
              value={"three_months"}
              label="3 Month"
            />
          </RadioGroup>
        </Row>
      </Section>
    );
  }
}

export default ReportFormat;



// WEBPACK FOOTER //
// ./client/modules/ReportForm/components/StageOne/ReportFormat/component.tsx